<template>
  <div class="wrapper-table">
    <v-data-table
      :headers="headersSerial"
      :items="data"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 my-4"
    >
      <template v-slot:item.status="{ item }">
        <div class="flex-center">
          <v-chip
            class="ma-2 v-chip-width"
            :color="item.status.color"
            width="50px"
          >
            <span class="text-white">
              {{ item.status.text }}
            </span>
          </v-chip>
        </div>
        {{ item.description_type }}
      </template>
      <template v-slot:item.image_url="{ item }">
        <span
          v-if="item.image_url"
          @click.stop="openImage(item.image_url)"
        >
          <div class="py-1">
            <v-img
              class="image-cover"
              width="50px"
              height="50px"
              :src="item.image_url"
              alt=""
            ></v-img>
          </div>
        </span>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      width="fit-content"
      max-width="90dvw"
      @keydown.esc="cancel"
    >
      <v-card class="py-4 px-4">
        <image-zoom
          :regular="pic"
          :zoom-amount="4"
          :click-zoom="true"
          img-class="img-fluid-zoom"
          close-pos="top-right"
          message-pos="top"
        ></image-zoom>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },

  data() {
    return {
      headersSerial: [
        {
          text: 'ซีเรียล',
          align: 'start',
          sortable: false,
          value: 'serial',
          width: '120px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          width: '280px',
        },
        {
          text: 'รูปภาพ',
          value: 'image_url',
          align: 'center',
          width: '100px',
        },
        {
          text: 'ผู้ตรวจสอบ',
          value: 'check_by',
          align: 'start',
          width: '140px',
        },
        {
          text: 'เวลาอัพเดท',
          value: 'updated_timestamp',
          align: 'start',
          width: '200px',
        },
        {
          text: 'วันที่รับสินค้าเข้าล่าสุด',
          value: 'stock_in',
          align: 'start',
        },
      ],
      dialog: false,
    }
  },

  methods: {
    openImage(imageUrl) {
      if (imageUrl) {
        this.pic = imageUrl
        this.dialog = true
      }
    },
    getScanBarcode(val) {
      return val === 1
    },
  },
}
</script>

<style scoped>
.wrapper-table {
  min-width: calc(100dvw - 56px);
  max-width: calc(100dvw - 56px);

  @media screen and (min-width: 768px) {
    max-width: unset;
  }
}
.theme--light.v-data-table
  /deep/
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}

/deep/ tbody tr {
  background-color: #fff !important;
}

/deep/ .v-chip.v-size--default {
  width: 150px;
}
</style>
